import { QuestionMarkCircleIcon } from "@heroicons/react/20/solid";

export const FieldDescription = ({ description = "" }) => {
  return (
    <div title={description}>
      <QuestionMarkCircleIcon height={18} width={18} strokeWidth={2} />
    </div>
  );
};
